import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { EditorEligibilityOperator } from '../editor-eligibility-operator/editor-eligibility-operator.model';


@Component({
    selector: 'eas-editor-eligibility-operator-children-title',
    templateUrl: './editor-eligibility-operator-children-title.component.html',
    styleUrls: ['./editor-eligibility-operator-children-title.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityOperatorChildrenTitleComponent implements OnInit {
  @Input() childOperators: EditorEligibilityOperator[];
  @Input() affirmative: boolean;
  @Input() function: 'and' | 'or';

  constructor() {

  }

  ngOnInit() {

  }
}
